import { render, staticRenderFns } from "./RooofAccountAdd.vue?vue&type=template&id=15391f40&scoped=true&"
import script from "./RooofAccountAdd.vue?vue&type=script&lang=js&"
export * from "./RooofAccountAdd.vue?vue&type=script&lang=js&"
import style0 from "./RooofAccountAdd.vue?vue&type=style&index=0&id=15391f40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15391f40",
  null
  
)

export default component.exports